import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Head from 'next/head';
import { useState } from 'react';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';
import CategoriesSidebarWrapper from '@/components/ShopComp/CategoriesSidebarWrapper';
import BooksListWrapper from '@/components/ShopComp/ProductListWrapper';
import HeroSection from '@/components/V2/HomePage/HeroSection';


const ShopPage = () => {
  
  const screens = useBreakpoint();

  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchKeyword = e.target.value;
    setSearchKeyword(newSearchKeyword);
  };

  

  
  return (
    <>
      <Head>
        <title>
          Explore Finance Books at ZebraLearn: Your Online Bookstore
        </title>
        <meta
          name='description'
          content='Discover best books publisher in India specializing in non-fiction books. ZebraLearn offers cutting-edge design & technology insights, simplifying complex topics.
      '
          key='description'
        />
      </Head>
      <div className='flex flex-col gap-y-2'>
        <HeroSection />
        <div className=' text-white pt-2 lg:pt-6 lg:px-8 xl:px-12'>
          <div className='flex flex-col md:flex-row'>
            <ShouldRender check={screens.lg}>
              <CategoriesSidebarWrapper
                handleInputChange={handleInputChange}
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                type='schools'
              />
            </ShouldRender>
            <div className='flex-1  md:px-6'>
              <BooksListWrapper
                handleInputChange={handleInputChange}
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                type='schools'
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopPage;
